/**
 * Golden Shoe draw — exact mirror of contracts/src/libraries/PrizeDraw.sol and RunnerPrizes._findEntry.
 */
import { encodeAbiParameters, keccak256, type Hex } from 'viem';

const MAX_UINT = (1n << 256n) - 1n;
export const MAX_ATTEMPTS = 64;

export function ticket(seed: Hex, shoeId: bigint, totalWeight: bigint): bigint {
  if (totalWeight === 0n) throw new Error('EmptyDraw');
  const limit = MAX_UINT - (MAX_UINT % totalWeight);
  for (let i = 0; i < MAX_ATTEMPTS; i++) {
    const r = BigInt(
      keccak256(
        encodeAbiParameters(
          [{ type: 'bytes32' }, { type: 'string' }, { type: 'uint256' }, { type: 'uint256' }],
          [seed, 'GOLDEN_SHOE_DRAW', shoeId, BigInt(i)],
        ),
      ),
    );
    if (r < limit) return r % totalWeight;
  }
  throw new Error('DrawExhausted');
}

export interface Entry {
  participant: Hex;
  cumWeight: bigint;
}

/** First entry whose cumulative weight exceeds `t`. */
export function findEntry(entries: Entry[], t: bigint): number {
  let lo = 0;
  let hi = entries.length - 1;
  while (lo < hi) {
    const mid = Math.floor((lo + hi) / 2);
    if (entries[mid].cumWeight > t) hi = mid;
    else lo = mid + 1;
  }
  return lo;
}

export function drawWinner(seed: Hex, shoeId: bigint, entries: Entry[]): { ticket: bigint; index: number; winner: Hex } {
  const total = entries.length ? entries[entries.length - 1].cumWeight : 0n;
  const t = ticket(seed, shoeId, total);
  const index = findEntry(entries, t);
  return { ticket: t, index, winner: entries[index].participant };
}
